var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"img",attrs:{"src":"http://yxfmm.bjyxfl.com/imgs/tg.png","alt":""}})])
}]

export { render, staticRenderFns }